import api from './api'
import { getTenantId } from '../config/tenant'

const base = () => `/tenants/${getTenantId()}/ad`

export const adApi = {
  // ─── Configs ───────────────────────────────────────────────────
  getConfigs: () =>
    api.get(`${base()}/configs`).then((r) => r.data),

  getConfig: (configId) =>
    api.get(`${base()}/configs/${configId}`).then((r) => r.data),

  createConfig: (data) =>
    api.post(`${base()}/configs`, data).then((r) => r.data),

  updateConfig: (configId, data) =>
    api.put(`${base()}/configs/${configId}`, data).then((r) => r.data),

  deleteConfig: (configId) =>
    api.delete(`${base()}/configs/${configId}`).then((r) => r.data),

  testConnection: (configId) =>
    api.post(`${base()}/configs/${configId}/test-connection`).then((r) => r.data),

  // ─── Stats do dashboard ────────────────────────────────────────
  getStats: (configId) =>
    api.get(`${base()}/configs/${configId}/stats`).then((r) => r.data),

  // ─── Árvore de OUs ─────────────────────────────────────────────
  getOuTree: (configId) =>
    api.get(`${base()}/configs/${configId}/ou-tree`).then((r) => r.data),

  // ─── Wizard de descoberta ──────────────────────────────────────
  discover: (data) =>
    api.post(`${base()}/discover`, data).then((r) => r.data),

  // ─── Permissões ────────────────────────────────────────────────
  getPermissions: (configId) =>
    api.get(`${base()}/configs/${configId}/permissions`).then((r) => r.data),

  updatePermissions: (configId, data) =>
    api.put(`${base()}/configs/${configId}/permissions`, data).then((r) => r.data),

  // ─── Group search (AD direto) ──────────────────────────────────
  searchGroups: (configId, q = '') =>
    api.get(`${base()}/configs/${configId}/groups/search`, { params: { q } }).then((r) => r.data),

  // ─── Grupos gerenciados ────────────────────────────────────────
  getManagedGroups: (configId) =>
    api.get(`${base()}/configs/${configId}/managed-groups`).then((r) => r.data),

  adoptGroup: (configId, objectGuid) =>
    api.post(`${base()}/configs/${configId}/managed-groups/adopt`, { objectGuid }).then((r) => r.data),

  createManagedGroup: (configId, data) =>
    api.post(`${base()}/configs/${configId}/managed-groups`, data).then((r) => r.data),

  moveGroup: (configId, managedGroupId, targetOuDn) =>
    api.post(`${base()}/configs/${configId}/managed-groups/${managedGroupId}/move`, { targetOuDn }).then((r) => r.data),

  syncGroup: (configId, managedGroupId) =>
    api.post(`${base()}/configs/${configId}/managed-groups/${managedGroupId}/sync`).then((r) => r.data),

  unmanageGroup: (configId, managedGroupId) =>
    api.delete(`${base()}/configs/${configId}/managed-groups/${managedGroupId}`).then((r) => r.data),

  // ─── Membros de grupo ──────────────────────────────────────────
  searchUsers: (configId, q = '') =>
    api.get(`${base()}/configs/${configId}/users/search`, { params: { q } }).then((r) => r.data),

  getGroupMembers: (configId, groupDn) =>
    api.get(`${base()}/configs/${configId}/groups/members`, { params: { groupDn } }).then((r) => r.data),

  createGroup: (configId, data) =>
    api.post(`${base()}/configs/${configId}/groups`, data).then((r) => r.data),

  addMember: (configId, groupDn, userIdentifier) =>
    api.post(`${base()}/configs/${configId}/groups/members`, { groupDn, userIdentifier }).then((r) => r.data),

  removeMember: (configId, groupDn, userIdentifier) =>
    api.delete(`${base()}/configs/${configId}/groups/members`, { data: { groupDn, userIdentifier } }).then((r) => r.data),

  // ─── Rules ─────────────────────────────────────────────────────
  getRules: (configId) =>
    api.get(`${base()}/configs/${configId}/rules`).then((r) => r.data),

  createRule: (configId, data) =>
    api.post(`${base()}/configs/${configId}/rules`, data).then((r) => r.data),

  updateRule: (configId, ruleId, data) =>
    api.put(`${base()}/configs/${configId}/rules/${ruleId}`, data).then((r) => r.data),

  deleteRule: (configId, ruleId) =>
    api.delete(`${base()}/configs/${configId}/rules/${ruleId}`).then((r) => r.data),

  // ─── Conta de serviço svc-automais ────────────────────────────
  // Wizard (antes de criar o config): provisionamento sem configId
  provisionServiceAccount: (data) =>
    api.post(`${base()}/provision-service-account`, data).then((r) => r.data),
  // Pós-criação: sincroniza a partir de um config existente
  syncServiceAccount: (configId, data) =>
    api.post(`${base()}/configs/${configId}/sync-service-account`, data).then((r) => r.data),

  // ─── AD Users ──────────────────────────────────────────────────
  getAdUsers: () =>
    api.get(`${base()}/users`).then((r) => r.data),
}

// ─── Audit ─────────────────────────────────────────────────────
const auditBase = () => `/tenants/${getTenantId()}/audit`

export const auditApi = {
  getLogs: (params = {}) =>
    api.get(auditBase(), { params }).then((r) => ({
      data: r.data,
      total: parseInt(r.headers['x-total-count'] || '0', 10),
    })),

  getLog: (logId) =>
    api.get(`${auditBase()}/${logId}`).then((r) => r.data),

  getAuditUsers: () =>
    api.get(`${auditBase()}/users`).then((r) => r.data),

  // Busca log de erro pelo errorCode global (sem tenant — backend resolve a partir do Guid).
  // Usado quando o usuário recebe um errorCode na resposta de uma API e cola na busca.
  getErrorLog: (errorCode) =>
    api.get(`/audit/error/${errorCode}`).then((r) => r.data),
}

